scroll-to-top {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 1.25rem;
  right: 1.25rem;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 100%;
  z-index: 1000;
  background: var(--brand-primary, #FF6600);
  color: #fff;
  transition: opacity 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), visibility 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}
scroll-to-top:not(.active) {
  opacity: 0;
  visibility: hidden;
}